"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _excluded = ["fill"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/*eslint-disable */
var _default = function _default(_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#B2ADA6' : _ref$fill,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement("g", {
    "data-testid": "rain-icon"
  }, /*#__PURE__*/_react["default"].createElement("path", _extends({}, rest, {
    d: "M11.5484 21.5075C11.2783 22.1544 10.5219 22.4509 9.87359 22.1813C9.22526 21.9118 8.92811 21.1571 9.19825 20.5102C9.46838 19.8633 11.4134 18.6234 11.4134 18.6234C11.4134 18.6234 11.8186 20.8606 11.5484 21.5075Z",
    fill: fill
  })), /*#__PURE__*/_react["default"].createElement("path", _extends({}, rest, {
    d: "M15.4653 21.5075C15.1952 22.1544 14.4388 22.4509 13.7905 22.1813C13.1421 21.9118 12.845 21.1571 13.1151 20.5102C13.3853 19.8633 15.3302 18.6234 15.3302 18.6234C15.3302 18.6234 15.7624 20.8606 15.4653 21.5075Z",
    fill: fill
  })), /*#__PURE__*/_react["default"].createElement("path", _extends({}, rest, {
    d: "M19.4094 21.5075C19.1393 22.1544 18.3829 22.4509 17.7345 22.1813C17.0862 21.9118 16.7891 21.1571 17.0592 20.5102C17.3293 19.8633 19.2743 18.6234 19.2743 18.6234C19.2743 18.6234 19.6795 20.8606 19.4094 21.5075Z",
    fill: fill
  })), /*#__PURE__*/_react["default"].createElement("path", _extends({}, rest, {
    d: "M10.5051 10.145C10.2501 10.145 9.91006 10.06 9.57005 10.06C7.61502 10.06 6 11.6751 6 13.6301C6 15.5851 7.61502 17.2001 9.57005 17.2001H14.7551V7C12.8001 7.085 11.1001 8.36002 10.5051 10.145Z",
    fill: fill
  })), /*#__PURE__*/_react["default"].createElement("path", _extends({}, rest, {
    d: "M23 13.9701C23 12.2701 21.64 10.9101 19.94 10.9101C19.77 10.9101 19.6 10.9101 19.4299 10.9951C19.1749 8.70002 17.2199 7 14.8399 7H14.7549V17.2001H19.94C21.555 17.0301 23 15.6701 23 13.9701Z",
    fill: fill
  })));
};

exports["default"] = _default;